import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import { checkCreativeFontUploaded, getCampaigns, getVersions, openCampaign, setCreativeFigmaBeforePreview, setCreativesDynamicText, setHtmlCreativesPreview, setPreviewFonts } from '../../../slices/campaigns/thunk';
import { Container, Row, Col, Card, CardHeader, CardBody, CardFooter, Input, Label } from 'reactstrap';
import EmptyPage from './Display/Image/EmptyPage';
import VersionPage from "./Display/Image/VersionPage";
import { getUploadLimits } from '../../../slices/uploads/thunk';
import { setBreadcrumb, setCampaignPath, setVersionPath } from '../../../slices/auth/menu/reducer';
import { setPreloader } from '../../../slices/layouts/reducer';
import { getAllLibrariesSuccess, getVersionsSuccess, setActiveDynamicText, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage, setCampaignLoader, setConnectedFeed, setConnectedFeedName, setCreatives, setCurrentCampaign, setCurrentVersion, setDynamicText, setFacebookId, setFilteredCreatives, setFilteredFontList, setFontUpdated, setIsFacebookProperties, setProperties, setTemplateLoader } from '../../../slices/campaigns/reducer';
import { replace } from "redux-first-history";
import Image from "./Display/Image";
import Html from "./Display/Html";
import { setUploadedFiles, setUploadLimits } from '../../../slices/uploads/reducer';
import Facebook from './Social/Facebook';
import DeleteCreativeModal from './Components/Modals/DeleteCreativeModal';
import DuplicateCreativeModal from './Components/Modals/DuplicateCreativeModal';
import { putCreative } from '../../../helpers/backend_helper';

function Campaign() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const selectStates = createSelector(state => state, state => ({
    campaignPath: state.MenuData.campaignPath,
    previousLocations: state.router.previousLocations,
    currentCampaign: state.Campaign.currentCampaign,
    currentVersion: state.Campaign.currentVersion,
    facebookProperties: {
      _id: state.Campaign.facebookId,
      properties: {
        title: state.Campaign.title,
        description: state.Campaign.description,
        availability: state.Campaign.availability,
        condition: state.Campaign.condition,
        price: state.Campaign.price,
        link: state.Campaign.link,
        image_link: state.Campaign.image_link,
      },
      brandId: state.Campaign.brand,
      interval: state.Campaign.interval,
      exportType: 'image',
      limit: state.Campaign.limit,
    },
    connectedFeed: state.Campaign.connectedFeed,
    connectedFeedName: state.Campaign.connectedFeedName,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    creatives: state.Campaign.creatives,
    filteredCreatives: state.Campaign.filteredCreatives,
    filteredFontList: state.Campaign.filteredFontList,
    uploadLimits: state.Upload.uploadLimits,
    campaignLoader: state.Campaign.campaignLoader,
    campaignPath: state.MenuData.campaignPath,
    previousLocations: state.router.previousLocations,
    title: state.MenuData.title,
    fontUpdated: state.Campaign.fontUpdated
  }));
  const {
    version,
    currentCampaign,
    currentVersion,
    facebookProperties,
    connectedFeed,
    connectedFeedName,
    dynamicText,
    activeDynamicText,
    creatives,
    filteredCreatives,
    filteredFontList,
    uploadLimits,
    campaignLoader, 
    campaignPath, 
    previousLocations,  
    title, 
    fontUpdated 
  } = useSelector(selectStates);
  useEffect(() => {
    async function handleHistoryState() {
      if ((previousLocations[0].location.state === null || (previousLocations.length > 1 ? previousLocations[1].location.pathname.includes('publish') : false)) 
        && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP")) {
        // dispatch(setCampaignPath(params.campaignId))
        dispatch(setCampaignLoader(true));
        dispatch(getAllLibrariesSuccess(null));
        dispatch(setAllLibrariesLoading(false));
        dispatch(setAllLibrariesHasMore(true));
        dispatch(setAllLibrariesFirstLoad(false));
        dispatch(setAllLibrariesPage(1));
        dispatch(setFilteredCreatives([]));
        dispatch(setBreadcrumb({pageTitle: 'Ad Library', title: []}));
        dispatch(getCampaigns()).then(async campaignRes => {
          const foundCampaign = campaignRes.payload.find(item => item._id === params.campaignId);
          if (foundCampaign) {
            await dispatch(openCampaign(foundCampaign));
          }
        });
      } else if (previousLocations[0].location.state !== null) {
        // Campaign 
        // dispatch(getAllLibrariesSuccess(previousLocations[0].location.state.campaigns));
        // dispatch(setAllLibrariesHasMore(previousLocations[0].location.state.hasMore));
        // dispatch(setAllLibrariesFirstLoad(previousLocations[0].location.state.firstLoad));
        // dispatch(setAllLibrariesPage(previousLocations[0].location.state.campaignPage));
        // Creative        
        dispatch(getVersionsSuccess(previousLocations[0].location.state.versions));
        dispatch(setCurrentCampaign(previousLocations[0].location.state.currentCampaign));
        dispatch(setCurrentVersion(previousLocations[0].location.state.currentVersion));
        if (previousLocations[0].location.state.facebookProperties) {
          dispatch(setProperties(previousLocations[0].location.state.facebookProperties));
          dispatch(setIsFacebookProperties(previousLocations[0].location.state.isFacebookPropertiesSet));
        }
        dispatch(setConnectedFeed(previousLocations[0].location.state.connectedFeed));
        dispatch(setConnectedFeedName(previousLocations[0].location.state.connectedFeedName));
        dispatch(setDynamicText(previousLocations[0].location.state.dynamicText));
        dispatch(setActiveDynamicText(previousLocations[0].location.state.activeDynamicText));
        dispatch(setCreatives(previousLocations[0].location.state.creatives));
        dispatch(setFilteredCreatives(previousLocations[0].location.state.creatives));
        dispatch(setFilteredFontList(previousLocations[0].location.state.fontRes));
        dispatch(setUploadLimits(previousLocations[0].location.state.uploadLimits));
        dispatch(setBreadcrumb({ pageTitle: 'Ad Library', title: (previousLocations[0].location.state?.title || []) }));
        dispatch(setCampaignLoader((previousLocations[0].location.state.campaignLoader ? previousLocations[0].location.state.campaignLoader : false)));
      }
    }
    handleHistoryState();
  }, [location]);

  return (
    <React.Fragment>
      {currentCampaign ?
        currentCampaign?.adType === "display" ?
          currentCampaign.bannerType === "image" ?
            <Image />
            : currentCampaign.bannerType === "html" ?
              <Html />
              : null
          :
          currentCampaign?.adType === 'social' ?
            <Facebook />
            : null
        : null}
      <DeleteCreativeModal />
      <DuplicateCreativeModal />
    </React.Fragment>
  )
}

export default Campaign
